import React, { useState } from "react";
import { QuizObject } from "../../../../store/modquiz/quiz_objects/quiz-object";

import { SortableContainer, SortableContainerProps } from "react-sortable-hoc";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

import { NewObjectButtonContainer } from "../ObjectListAndDetail/AddObjectButton/NewObjectButtonContainer";
import ObjectDrawerMaker from './ObjectDrawerMaker';

type ObjectListProps = SortableContainerProps & {
    subjectHashKey: string;
    quiz_objects: Map<string, QuizObject>;
    hasCreateAccess: boolean;
    sortedQuizObjects: Array<string>;
    createObject: Function;
    pushQuizObject: Function;
};

const ObjectListComponent = ({
    quiz_objects,
    subjectHashKey,
    hasCreateAccess,
    sortedQuizObjects,
    createObject,
    pushQuizObject
}: ObjectListProps) => {
        let objectDrawer = [];
        let x = 0;

        let objectDrawerMaker = new ObjectDrawerMaker(
            quiz_objects,
            sortedQuizObjects,
            pushQuizObject,
            subjectHashKey
        );
        objectDrawerMaker.genSorted();
        objectDrawerMaker.genUnsorted();

        objectDrawer.push(
            <ListItem className="sidebar-new-object" key="new-card-key">
                <NewObjectButtonContainer
                    look="text"
                    show={hasCreateAccess}
                    createObject={createObject}
                />
            </ListItem>
        );

        return <List>{objectDrawerMaker.HTML()}</List>;
};

const ObjectList = SortableContainer(ObjectListComponent);

export default ObjectList;
